import * as yup from 'yup';

export const projectProfileSchema = yup.object().shape({
    project_id: yup.number().optional(),
    project_name: yup.string().required('Project Name is required'),
    trx_code: yup.string().required(),
    transaction_date: yup.string().required(),
    status_project: yup.number().required(),
    start_date: yup.string().required(),
    due_date: yup.string().required(),
    finished_date: yup.string().nullable().optional(),
    employee_id: yup.number().required('Manager is required field'),
    customer_id: yup.number().required('Sponsor is required field'),
    department_id: yup.number().required('Department is required field'),
    type_project: yup.number().required(),
    type_project_id: yup.number().required(),
    contact: yup.string().required(),
    approve_status: yup.number().required(),
    approve_date: yup.string().nullable().optional(),
    approve_by: yup.string().nullable().optional(),
    location_id: yup.string().nullable().optional(),
    link_asset_id: yup.number().nullable().optional(),
    description: yup.string().required(),
    project_profile_id: yup.number().optional(),
    budget:yup.number().nullable(),
    actual_budget:yup.number().nullable(),
    over_budget:yup.number().nullable()
});